import React, { useState, useMemo, useRef } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { useReactToPrint } from 'react-to-print';
import {
  Button,
  Box,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Modal,
  Paper,
  TextField,
  Typography
} from '@material-ui/core';
import { DataGrid } from '@material-ui/data-grid';

import CreditInvoice from 'components/Invoices/CreditInvoice';

import { decrementCustomerPayable } from 'redux/actions';
import { credit } from 'variables/paymentMethods';

const CustomerCreditModal = (props) => {
  
  const printRef = useRef();
  
  const [switchy, setSwitchy] = useState(0);
  const [currAmount, setCurrAmount] = useState("");

  const tableData = useMemo(() => {
    const initialTableData = [];

    for ( let i = 0; i < props.salesOrders.length; i++ ) {
      if(props.salesOrders[i].customerId === props.customerInfo.id && props.salesOrders[i].paymentMethod === credit) {
        const salesOrder = props.salesOrders[i];
        //'id' field is added only for the DataGrid object.
        initialTableData.push({
          id: salesOrder.displayId,
          displayId: salesOrder.displayId,
          name: props.customerInfo.name,
          date: moment(salesOrder.createdAt).format('DD/MM/YYYY'),
          total: salesOrder.total,
          paymentMethod: salesOrder.paymentMethod
        });
      }
    }

    return initialTableData;
    
  }, [props.salesOrders, props.customerInfo]);

  const columns = [
    { field: 'displayId', headerName: 'Order ID', flex: 1, sortable: false, disableColumnMenu: true },
    { field: 'name', headerName: 'Customer Name', flex: 1, sortable: false, disableColumnMenu: true },
    { field: 'date', headerName: 'Date', flex: 1, sortable: false, disableColumnMenu: true },
    { field: 'total', headerName: 'Total Amount', flex: 1, sortable: false, disableColumnMenu: true },
    { field: 'paymentMethod', headerName: 'Payment Method', flex: 1, sortable: false, disableColumnMenu: true }
  ];

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: "Credit Settlement"
  });

  const handlePayment = () => {
    props.decrementCustomerPayable({ id: props.customerInfo.id, decrementAmount: currAmount });

    setSwitchy(1);
  };

  const renderAll = () => {
    switch (switchy) {
      case 0:
        return (
          <Box>
            <Box
              sx={{
                overflow: 'auto',
                height: 318,
                marginBottom: '0.3%'
              }}
            >
              <DataGrid
                rows={tableData}
                columns={columns}
                disableSelectionOnClick
                hideFooter
                localeText={{
                  noRowsLabel: 'No Sales Orders'
                }}
              />
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
              }}
            >
              <Typography
                color="textPrimary"
                variant="h6"
                gutterBottom
              >
                {`Pending Credit : AED ${Number(props.customerInfo.payableAmount).toFixed(2)}`}
              </Typography>
              <TextField
                helperText="Please Enter the Settlement Amount"
                label="Amount"
                name="currAmount"
                onChange={(event) => setCurrAmount( parseFloat(event.target.value) || 0 )}
                value={currAmount}
                variant="outlined"
              />
              <Typography
                color="textPrimary"
                variant="h6"
                gutterBottom
              >
                {//This Displays the Balance Amount that will be left after current settlement.
                `Balance Credit : AED ${Math.round( props.customerInfo.payableAmount - currAmount )}`}
              </Typography>
              <Box 
                sx={{
                  display: 'flex',
                  gridGap: 8
                }}
              >
                <Button
                  disabled={currAmount <= 0}
                  variant="contained"
                  color="primary"
                  onClick={handlePayment}
                >
                  Settle
                </Button>
                <Button
                  color="primary"
                  onClick={props.closeModal}
                >
                  Cancel
                </Button>
              </Box>
            </Box>
          </Box>
        )
      
      case 1:
        return (
          <Box>
            <Paper
              style={{
                overflow: 'auto',
                maxHeight: 462
              }}
            >
              <CreditInvoice
                ref={printRef}
                info={{
                  displayId: props.customerInfo.displayId,
                  customerName: props.customerInfo.name,
                  paymentDate: new Date(),
                  total: currAmount
                }}
                user={props.user}
              />
            </Paper>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                paddingTop: '1%'
              }}
            >
              <Button
                color="primary"
                variant="contained"
                onClick={() => {
                  handlePrint();
                  props.closeModal();
                }}
              >
                Print Invoice
              </Button>
            </Box>
          </Box>
        )
      
      default:
        return (<React.Fragment></React.Fragment>)
    }
  };

  return (
    <Modal open={props.open}>
      <Card>
        <CardHeader
          subheader="Review and Settle Customer Credit"
          title="Customer Credit"
        />
        <Divider />
        <CardContent>
          {renderAll()}
        </CardContent>
      </Card>
    </Modal>
  )
};

export default connect (null, {decrementCustomerPayable}) (CustomerCreditModal);